export default __webpack_public_path__ + "static/about-us-sustainability--mobile-c03ef36a574c1c39b5c726680348e030.webp";